/*jshint esversion: 6 */
(function () {
    'use strict';
    $(function () {

        $('document').ready(function () {

            menu();
            $(window).on('resize', function () {
                menu();
            });

            function menu() {
                if ($(window).width() < 768) {
                    $('nav, .hamburger').removeClass('open').find('>ul').fadeOut();
                    $('.hamburger').off().click(function () {
                        if ($('nav').hasClass('open')) {
                            $('nav>ul').removeClass('open').slideUp();
                        } else {
                            $('nav>ul').addClass('open').slideDown();
                        }
                        $('nav, .hamburger, nav>ul').toggleClass('open');
                    });

                } else {
                    $('nav, .hamburger').removeClass('open');
                    $('nav>ul').removeClass('open').css('display', 'flex');
                }
            }
        });

    });
}(jQuery));
